(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ap-pool-card-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.apPoolCardSwatchesReady) return;
    window.apPoolCardSwatchesReady = true;

    // Delegation also covers cards replaced by collection sorting/filtering.
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target && target.closest('button[data-pool-card-color]');
      if (!button) return;
      const card = button.closest('[data-pool-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      card.querySelectorAll('button[data-pool-card-color]').forEach((item) => {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      card.dataset.poolSelectedVariant = button.dataset.variantId;

      const image = card.querySelector('.ap-product-card__image');
      if (image && button.dataset.imageSrc) {
        image.srcset = button.dataset.imageSrcset || '';
        image.src = button.dataset.imageSrc;
        image.alt = button.dataset.imageAlt || '';
      }

      const price = card.querySelector('[data-pool-card-price]');
      if (price) price.textContent = button.dataset.priceLabel;
      const caption = card.querySelector('[data-pool-card-caption]');
      if (caption) caption.textContent = button.dataset.colorCaption;
      card.querySelectorAll('a[data-pool-card-link]').forEach((link) => {
        link.href = button.dataset.productUrl;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-poolset-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectColor = button => {
      const card = button.closest('[data-poolset-card]');
      if (!card) return;
      card.querySelectorAll('[data-poolset-card-color]').forEach(item => {
        const selected = item === button;
        item.setAttribute('aria-checked', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      card.querySelector('[data-poolset-card-caption]').textContent = button.dataset.caption;
      card.querySelector('[data-poolset-card-price]').textContent = button.dataset.price;
      card.querySelectorAll('[data-poolset-link]').forEach(link => { link.href = button.dataset.url; });
      card.dataset.selectedVariant = button.dataset.variantId;
      card.dataset.selectedSku = button.dataset.sku;
      const image = card.querySelector('.ap-product-card__image');
      if (image && button.dataset.image) {
        image.srcset = button.dataset.imageSrcset;
        image.src = button.dataset.image;
        image.alt = button.dataset.imageAlt;
      }
    };
    document.addEventListener('click', event => {
      const button = event.target.closest?.('[data-poolset-card-color]');
      if (!button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      selectColor(button);
    });
    document.addEventListener('keydown', event => {
      const button = event.target.closest?.('[data-poolset-card-color]');
      if (!button || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', ' '].includes(event.key)) return;
      const buttons = Array.from(button.closest('[data-poolset-card]').querySelectorAll('[data-poolset-card-color]'));
      let index = buttons.indexOf(button);
      if (event.key === 'Home') index = 0;
      else if (event.key === 'End') index = buttons.length - 1;
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index = (index - 1 + buttons.length) % buttons.length;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index = (index + 1) % buttons.length;
      event.preventDefault();
      buttons[index].focus();
      selectColor(buttons[index]);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-poolset-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ap-poolset-picker')) {
    customElements.define('ap-poolset-picker', class extends HTMLElement {
      connectedCallback() {
        this.onChange = () => this.updateSelection();
        this.addEventListener('change', this.onChange);
        this.updateSelection();
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
      }
      updateSelection() {
        const input = this.querySelector('input[type="radio"]:checked');
        if (!input) return;
        this.querySelector('[data-poolset-selected-design]').textContent = input.dataset.poolsetCaption;
        this.variants ||= JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        const variant = this.variants.find(item => item.option1 === input.value);
        this.notReady = !variant || !variant.sku || variant.price <= 0;
        const section = this.closest('section');
        const button = section?.querySelector('button[name="add"]');
        this.querySelector('[data-poolset-unavailable]').hidden = !this.notReady;
        if (!button) return;
        const guard = () => {
          if (this.notReady && !button.disabled) button.disabled = true;
        };
        guard();
        if (!this.observer) {
          this.observer = new MutationObserver(guard);
          this.observer.observe(button, { attributes:true, attributeFilter:['disabled'] });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ap-scandi-card-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.apScandiCardSwatchesReady) return;
    window.apScandiCardSwatchesReady = true;

    // Delegation also covers cards replaced by collection sorting/filtering.
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const button = target && target.closest('button[data-scandi-card-color]');
      if (!button) return;
      const card = button.closest('[data-scandi-card]');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      card.querySelectorAll('button[data-scandi-card-color]').forEach((item) => {
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      card.dataset.scandiSelectedVariant = button.dataset.variantId;

      const image = card.querySelector('.ap-product-card__image');
      if (image && button.dataset.imageSrc) {
        image.srcset = button.dataset.imageSrcset || '';
        image.src = button.dataset.imageSrc;
        image.alt = button.dataset.imageAlt || '';
      }

      const price = card.querySelector('[data-scandi-card-price]');
      if (price) price.textContent = button.dataset.priceLabel;
      const caption = card.querySelector('[data-scandi-card-caption]');
      if (caption) caption.textContent = button.dataset.colorCaption;
      card.querySelectorAll('a[data-scandi-card-link]').forEach((link) => {
        link.href = button.dataset.productUrl;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
